import request from '@/utils/request'

const servicePrefix = process.env['VUE_APP_CSV_API'] || ''

export function getDetail(params) {
  return request({
    url: servicePrefix + '/detail',
    method: 'get',
    params
  })
}
export function getJson(params) {
  return request({
    url: servicePrefix + '/get-json',
    method: 'get',
    params
  })
}
export function clear() {
  return request({
    url: servicePrefix + '/clear',
    method: 'get'
  })
}
export function getFileNameList() {
  return request({
    url: servicePrefix + '/getFileNameList',
    method: 'get'
  })
}
export function getType() {
  return request({
    url: servicePrefix + '/getType',
    method: 'get'
  })
}

